// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { BusinessTypeEnum } from '~/utils/enum/common';
import { IFormNote } from '~/utils/interface/note';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      content: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
    })
    .required();
};

export const defaultValuesForm: IFormNote = {
  content: EMPTY_STRING,
  businessId: EMPTY_STRING,
  businessType: BusinessTypeEnum.ESTIMATE,
};
